import { makeRequest } from 'utils/requestLogger';

export default (course_id, edlink_course_id, users) =>
    makeRequest('post', `/api/courses/${course_id}/import-edlink-students`, {
        course_id: edlink_course_id,
        students: users,
    });



// WEBPACK FOOTER //
// ./src/app/services/courses/importStudentsFromEdlink.js